export function getUTCMidnight(timestamp: number): number {
  const date = new Date(timestamp * 1000);
  date.setUTCHours(0, 0, 0, 0);
  return Math.floor(date.getTime() / 1000);
}

export function getUTCHour(timestamp: number): number {
  const date = new Date(timestamp * 1000);
  date.setUTCMinutes(0, 0, 0);
  return Math.floor(date.getTime() / 1000);
}

export const truncateTimestampToInterval = (
  timestamp: number,
  interval: 'daily' | 'hourly',
  options?: { isEndDate?: boolean },
): number => {
  if (interval === 'daily') {
    // Keep daily normalization at UTC midnight for both start/end bounds.
    return getUTCMidnight(timestamp);
  }
  // Hourly: floor for start, ceil-to-hour-end for endDate when requested
  if (options?.isEndDate) {
    const hourStart = getUTCHour(timestamp);
    return hourStart + 3599;
  }
  return getUTCHour(timestamp);
};
